export default __webpack_public_path__ + "static/media/jiantai.0d93f219.png";